<template>
    <div class="d-flex align-items-center">
        <div v-if="row.CoverImage" class="mr-1">
            <img :src="row.CoverImage" class="rounded-circle border" style="width: 40px; height: 40px; object-fit: cover" alt="Cover" />
        </div>
        <div v-else class="avatar-content rounded-circle bg-light-primary p-2 mr-1" :style="{ backgroundColor: row.Color ? row.Color + '20' : '' }">
            <feather-icon :icon="row.Icon || 'FolderIcon'" size="18" :style="{ color: row.Color || '#7367f0' }" />
        </div>
        <div>
            <div class="font-weight-bolder text-dark">{{ field }}</div>
            <small class="text-muted d-block" style="font-size: 11px">{{ row.FolderKey }}</small>
        </div>
    </div>
</template>

<script>
export default {
    name: "TableFolderCell",
    props: {
        row: {
            type: Object,
            required: true,
        },
        field: {
            required: true,
        },
        k: {
            type: String,
            required: true,
        },
    },
};
</script>
